import React, { HTMLAttributes } from "react"
import Spin from "../Spin"
import styles from "./styles.module.scss"

interface IProps extends HTMLAttributes<HTMLButtonElement> {
  loading?: boolean
  disabled?: boolean
  type?: "primary" | "outline"
}

const Button: React.FC<IProps> = ({
  loading = false,
  className,
  style,
  children,
  disabled,
  type,
  onClick,
  ...extraProps
}) => {
  return (
    <div
      className={[
        styles.eufyBtnWrap,
        type && styles[type],
        disabled && styles.disabled,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={style}
    >
      <Spin spinning={loading} className={styles.btnSpin}>
        <button
          className={styles.eufyBtn}
          onClick={(e) => (loading ? null : onClick ? onClick(e) : null)}
          disabled={disabled}
          {...extraProps}
        >
          {children}
        </button>
      </Spin>
    </div>
  )
}

export default Button
